import { useEffect, useState } from 'react';

import {
  Grid,
  Typography,
  TextField,
  Button
} from '@material-ui/core';
import ArrowBackIcon from '@material-ui/icons/ArrowBack';
import SaveIcon from '@material-ui/icons/Save';
import { useHistory, useParams } from 'react-router-dom';
import { useSnackbar } from 'notistack';

import { ViewerComponent } from '../commons/viewer/viewer.component';
import { getUser, updateUser } from '../../services/users.service';
import { BackdropComponent } from '../commons/backdrop/backdrop.component';

export const UsersEditComponent = () => {

  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();
  const params = useParams();

  const [user, setUser] = useState({
    name: '',
    phone: '',
    email: '',
    address: '',
    active: true
  });

  const [loading, setLoading] = useState(true);

  const fetchUser = async (userId) => {
    const userItem = await getUser(userId);
    setUser(userItem);
    setLoading(false);
  }

  useEffect(() => {
    fetchUser(params.id);
  }, [params.id]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setUser({
      ...user,
      [name]: value
    });
  }

  const save = async () => {
    try {
      if (!/@gmail\.com$/.test(user.email)) {
        enqueueSnackbar('Introduce un correo de Gmail', {
          variant: 'error',
          resumeHideDuration: 6000,
          anchorOrigin:
            { horizontal: 'right', vertical: 'bottom' },
        });
        return;
      }
      const userEdit = await updateUser(params.id, user);
      enqueueSnackbar(`${userEdit.name} editado`, {
        variant: 'success',
        resumeHideDuration: 3000,
        anchorOrigin:
          { horizontal: 'right', vertical: 'bottom' },
      });
      history.push('/users');
    } catch (err) {
      enqueueSnackbar(JSON.stringify(err), {
        variant: 'error',
        resumeHideDuration: 6000,
        anchorOrigin:
          { horizontal: 'right', vertical: 'bottom' },
      });
    }
  }

  return loading ? (
    <BackdropComponent />
  ) : (
    <ViewerComponent>
      <Grid container justifyContent="center" spacing={2}>
        <Grid item xs={10}>
          <Typography variant="h4">
            Editar usuario
          </Typography>
        </Grid>
        <Grid item xs={10}>
          <TextField
            id="name"
            name="name"
            label="Nombre"
            variant="outlined"
            onChange={handleChange}
            defaultValue={user.name}
            fullWidth
          />
        </Grid>
        <Grid item xs={10}>
          <TextField
            id="phone"
            name="phone"
            label="Teléfono"
            variant="outlined"
            fullWidth
            onChange={handleChange}
            defaultValue={user.phone}
          />
        </Grid>
        <Grid item xs={10}>
          <TextField
            id="email"
            name="email"
            label="Correo electrónico"
            variant="outlined"
            helperText="Con este correo ingresará a la aplicación, debe ser un correo de Gmail"
            fullWidth
            onChange={handleChange}
            defaultValue={user.email}
          />
        </Grid>
        <Grid item xs={10}>
          <TextField
            id="address"
            name="address"
            label="Dirección"
            variant="outlined"
            fullWidth
            onChange={handleChange}
            defaultValue={user.address}
          />
        </Grid>
        <Grid item xs={10}>
          <Grid container justifyContent="flex-end" spacing={2}>
            <Grid item>
              <Button
                variant="contained"
                color="default"
                startIcon={<ArrowBackIcon />}
                onClick={() => history.goBack()}
              >
                Regresar
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                color="primary"
                startIcon={<SaveIcon />}
                onClick={save}
                disabled={!user.name || !user.email || !user.phone}
              >
                Guardar
              </Button>
            </Grid>
          </Grid>
        </Grid>
      </Grid>
    </ViewerComponent>
  )
}